import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { locales } from '../../../../i18n';
export var fetchMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var localeKey, messages, parentLocale, _messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          localeKey = locale.replace('-', '_');
          if (!(localeKey in locales)) {
            _context.next = 7;
            break;
          }
          _context.next = 5;
          return locales[localeKey]();
        case 5:
          messages = _context.sent;
          return _context.abrupt("return", messages.default);
        case 7:
          _context.next = 11;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
        case 11:
          _context.prev = 11;
          parentLocale = locale.split(/[-_]/)[0];
          if (!(parentLocale in locales)) {
            _context.next = 18;
            break;
          }
          _context.next = 16;
          return locales[parentLocale]();
        case 16:
          _messages = _context.sent;
          return _context.abrupt("return", _messages.default);
        case 18:
          _context.next = 22;
          break;
        case 20:
          _context.prev = 20;
          _context.t1 = _context["catch"](11);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9], [11, 20]]);
  }));
  return function fetchMessagesForLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();